import { render, staticRenderFns } from "./PortalResidenceTab.vue?vue&type=template&id=4c656e63&"
import script from "./PortalResidenceTab.vue?vue&type=script&lang=js&"
export * from "./PortalResidenceTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports